export default __webpack_public_path__ + "static/media/custom-questions.f822a06a.svg";